"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/form-controls"),
    getLabelsForLabelable = _require.getLabelsForLabelable;

var _require2 = require("../helpers/strings"),
    parseFloatingPointNumber = _require2.parseFloatingPointNumber;

var HTMLProgressElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLProgressElementImpl, _HTMLElementImpl);

  function HTMLProgressElementImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, HTMLProgressElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLProgressElementImpl).call(this, globalObject, args, privateData));
    _this._labels = null;
    return _this;
  }

  _createClass(HTMLProgressElementImpl, [{
    key: "_isDeterminate",
    get: function get() {
      return this.hasAttributeNS(null, "value");
    } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-progress-value

  }, {
    key: "_value",
    get: function get() {
      var valueAttr = this.getAttributeNS(null, "value");
      var parsedValue = parseFloatingPointNumber(valueAttr);

      if (parsedValue !== null && parsedValue > 0) {
        return parsedValue;
      }

      return 0;
    } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-progress-current-value

  }, {
    key: "_currentValue",
    get: function get() {
      var value = this._value;
      return value > this.max ? this.max : value;
    }
  }, {
    key: "value",
    get: function get() {
      if (this._isDeterminate) {
        return this._currentValue;
      }

      return 0;
    },
    set: function set(value) {
      this.setAttributeNS(null, "value", value);
    }
  }, {
    key: "max",
    get: function get() {
      var max = this.getAttributeNS(null, "max");

      if (max !== null) {
        var parsedMax = parseFloatingPointNumber(max);

        if (parsedMax !== null && parsedMax > 0) {
          return parsedMax;
        }
      }

      return 1.0;
    },
    set: function set(value) {
      if (value > 0) {
        this.setAttributeNS(null, "max", value);
      }
    }
  }, {
    key: "position",
    get: function get() {
      if (!this._isDeterminate) {
        return -1;
      }

      return this._currentValue / this.max;
    }
  }, {
    key: "labels",
    get: function get() {
      return getLabelsForLabelable(this);
    }
  }]);

  return HTMLProgressElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLProgressElementImpl
};